import React from "react";
import { Link } from "react-router-dom";
import "../css/about.scss";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="about-page">
      <section className="about-hero" aria-labelledby="about-title">
        <img
          className="about-hero__image"
          src="/a-story.png"
          alt="A denim maker reviewing a pair of dark indigo jeans in a workroom"
        />
        <div className="about-hero__shade" aria-hidden="true" />
        <div className="about-hero__content">
          <p className="about-kicker">Our story</p>
          <h1 id="about-title">We are nartvmora</h1>
          <p>Denim shaped by real life, thoughtful detail and enduring fit.</p>
        </div>
      </section>

      <section className="about-origin about-shell" aria-labelledby="origin-title">
        <div className="about-origin__stamp" aria-label="Independent design studio">
          <span>Independent</span>
          <strong>Studio</strong>
        </div>
        <div className="about-origin__copy">
          <p className="about-kicker">Where it began</p>
          <h2 id="origin-title">A considered point of view</h2>
          <p>
            nartvmora began with one clear ambition: make denim that feels
            considered without feeling complicated. We
            started at the cutting table, learning how proportion, wash and
            fabric can change the way a pair of jeans moves through a day.
          </p>
          <p>
            That practical curiosity still guides us. Every collection is
            refined around the people who wear it&mdash;their routines, their
            confidence and the ease they expect from a trusted wardrobe.
          </p>
        </div>
      </section>

      <section className="about-craft" aria-labelledby="craft-title">
        <div className="about-shell">
          <div className="about-craft__intro">
            <p className="about-kicker">Our approach</p>
            <h2 id="craft-title">Designed from the details up</h2>
          </div>

          <div className="about-craft__grid">
            <article className="about-value">
              <span className="about-value__number" aria-hidden="true">
                01
              </span>
              <h3>Fit comes first</h3>
              <p>
                We balance rise, line and proportion until the silhouette feels
                natural on the body. The result is denim that gives structure
                without asking you to stand still.
              </p>
            </article>

            <article className="about-value">
              <span className="about-value__number" aria-hidden="true">
                02
              </span>
              <h3>Made for repeat wear</h3>
              <p>
                Strong construction and carefully chosen fabrics are central to
                every piece. We design for the rhythm of a real wardrobe, where
                favourites are worn often and become better with time.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section
        className="about-responsibility"
        aria-labelledby="responsibility-title"
      >
        <div className="about-shell about-responsibility__inner">
          <div>
            <p className="about-kicker">Made with accountability</p>
            <h2 id="responsibility-title">A more responsible way to make</h2>
          </div>
          <div className="about-responsibility__copy">
            <p>
              For nartvmora, ethical manufacturing is an ongoing practice:
              respecting the people behind each garment, questioning every
              process and choosing progress over shortcuts.
            </p>
            <ul aria-label="Responsible manufacturing priorities">
              <li>Long-term, transparent working relationships</li>
              <li>Considered materials and lower-impact wash decisions</li>
              <li>Quality built to extend the useful life of every garment</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="about-cta" aria-labelledby="about-cta-title">
        <p className="about-kicker">Designed to fit. Made to last.</p>
        <h2 id="about-cta-title">Find the denim that feels like yours.</h2>
        <Link className="about-cta__link" to="/shop" onClick={toTop}>
          Shop the collection
          <span aria-hidden="true">&rarr;</span>
        </Link>
      </section>
    </main>
  );
}

export default About;
